import React, { useState, useEffect } from "react";
import { JobService } from "../../../services/JobService";
import TreeView from "react-treeview";
import $ from "jquery";
import ReactStars from "react-rating-stars-component";
import { toast } from "react-toastify";

import {
  Row,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Button,
  Form,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Table,
  CardHeader,
  CardFooter,
} from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import { Link, useParams } from "react-router-dom";
import { getEnumLists } from "../../../services/MetadataService";

const SkillSearch = (props) => {

  const {parentCallback,deletedList}=props;
  const [modalSkill, setModalSkill] = useState(false);
  const [languageshow, setlanguageShow] = useState(true);
  const [treeview, setTreeview] = useState(false);
  const [categories, setCategories] = useState([]);
  const [ratingSelectedList, setRatingSelectedList] = useState([]);
  const [skillSelectedList, setSkillSelectedList] = useState([]);
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [jobSkillLevels, setJobSkillLevels] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [skillIds, setSkillIds] = useState([]);
  const [rating, setRating] = useState(0);
  const [jobStatus, setJobStatus] = useState("");
  const [candidateSkills, setCandidateSkills] = useState([]);
  const [newList, setNewList] = useState([]);
  const [searchSkill,setSearchSkill]=useState([])

  useEffect(() => {
    getTotalSkillList();
  }, []);

  const onAddSkills = () => {
    setModalSkill(true);
   setFilteredSkills(searchSkill);
  };
 
  useEffect(()=>{
     setNewList(deletedList)
  },[deletedList])

  const getTotalSkillList = () => {
    JobService.getSkillsService().then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          var skillDetails = response.data;
          if (skillDetails != null) {
            
            setFilteredSkills(skillDetails.indlist);
            setSearchSkill(skillDetails.indlist)

            skillDetails.indlist.length > 0 &&
              skillDetails.indlist.map((industrydetails, index) => {
                industrydetails.categories.length > 0 &&
                  industrydetails.categories.map((category, index) => {
                    category.skills.length > 0 &&
                      category.skills.map((skill, indexval) => {
                        category.skills[indexval].rating = 0;
                        category.skills[indexval].isDisabled = false;
                        category.skills[indexval].skillLevel = "";
                      });
                  });
              });
           
            setFilteredSkills(skillDetails.indlist);
            setSearchSkill(skillDetails.indlist)
          }
        }
      } catch (err) {}
    });
  };
 
 const checkCheckedStatus =(skill)=>{
  var flag = false;
  for(var i=0;i<newList.length;i++){
    if(skill.id==newList[i].id){
      flag = true;
    }
  }
  return flag;
 }
  const handleCheck = (event, skill) => {
 var tempSelectedList=[...newList]
    if (event.target.checked) {
      tempSelectedList.push(skill)
      setNewList(tempSelectedList);
    } 
    else if (event.target.checked===false) {
      
      setNewList(newList.filter(item=>item.id!==skill.id))
    }
   
  };

  const onAddSkillSearch = () => {
    parentCallback(newList);
    setFilteredSkills(searchSkill)
    setModalSkill(false);
  };

  const onCancleSkillSearch=()=>{
    setModalSkill(false);
    setFilteredSkills(searchSkill)
  }

  // const searchItems = (searchValue) => {
  //   console.log("searchValue===="+ JSON.stringify(searchValue))
    
  //   setFilteredSkills(searchSkill.filter(searchItem=>(searchItem.industry.toLowerCase()).includes(searchValue.toLowerCase())))
  // };

  // const searchItems = (searchValue) => {
  //   setlanguageShow(true);
  //   if (searchValue !== "") {
  //     if (searchValue.length >= 3) {
  //       setTreeview(false);
  //       JobService.searchSkill(searchValue).then((response) => {
  //         try {
  //           if (response.message != null) {
  //             if (response.data.error_message !== "") {
  //             }
  //           } else {
  //             if (response.data != null) {
  //               response.data.indlist.length > 0 &&
  //                 response.data.indlist.map((industrydetails, index) => {
  //                   industrydetails.categories.length > 0 &&
  //                     industrydetails.categories.map((category, index) => {
  //                       category.skills.length > 0 &&
  //                         category.skills.map((skill, indexval) => {
  //                           setFilteredSkills(response.data.indlist);
  //                         });
  //                     });
  //                 });
  //                 setFilteredSkills(response.data.indlist);
  //             }
  //           }
  //         } catch (err) {}
  //       });
  //     } 
  //   } 
  // };
  const [searchInput, setSearchInput] = useState("");

  const searchItems = (searchValue) => {
    setSearchInput(searchValue);
    if (searchValue !== "" && searchValue.length >= 3) {
      setTreeview(false);
      JobService.searchSkill(searchValue).then((response) => {
        try {
          if (response.data != null) {
            setFilteredSkills(response.data.indlist);
          }
        } catch (err) {
          console.log(err);
        }
      });
    } else {
      
      setTreeview(true);
      setFilteredSkills(searchSkill);
    }
  };
  // const updateSkillDetails = (skillsList) => {
  //   if (skillsList.length > 0) {
  //     skillsList.map((industrydetails, index) => {
  //       industrydetails.categories.length > 0 &&
  //         industrydetails.categories.map((category, index) => {
  //           category.skills.length > 0 &&
  //             category.skills.map((skill, indexval) => {
  //               category.skills[indexval].rating = 0;
  //               category.skills[indexval].isDisabled = false;
  //               ratingSelectedList.length > 0 &&
  //                 ratingSelectedList.map((rateskill, indexval1) => {
  //                   if (rateskill.skillId == skill.skillId) {
  //                     category.skills[indexval].rating = rateskill.rating;
  //                   }
  //                 });
  //               // // categoryId
  //               skillSelectedList.length > 0 &&
  //                 skillSelectedList.map((selectedSkill, index) => {
  //                   if (selectedSkill.skillId == skill.skillId) {
  //                     if (selectedSkill.categoryId == category.id) {
  //                       //   category.skills[indexval].isDisabled=true
  //                       category.skills[indexval].skillLevel =
  //                         selectedSkill.skillLevel;
  //                     } else {
  //                       category.skills[indexval].isDisabled = true;
  //                       category.skills[indexval].skillLevel = "";
  //                     }
  //                   }
  //                   // if(sele)
  //                 });
  //             });
  //         });
  //     });
  //     setFilteredSkills(skillsList);
  //   } else {
  //     setFilteredSkills([]);
  //   }
  // };
  return (
    <>
      <Button
        className="btn-sm mt-1 t-button-skill-edu btn "
        type="submit"
        color="primary"
        outline
        onClick={onAddSkills}
      >
        + Skills
      </Button>

      <Modal
        scrollable={true}
        isOpen={modalSkill}
        toggle={() => setModalSkill(!modalSkill)}
      >
        <ModalHeader className="mdl_header">
          <div>
            <strong>Select skills</strong>
          </div>
        </ModalHeader>
        <ModalBody className="labelSize">
          <div className="col-lg-12 p-0">
            <Input
              type="text"
              icon="search"
              placeholder="Search for skills"
              onChange={(e) => searchItems(e.target.value)}
            />
          </div>

          {languageshow &&
            filteredSkills.length > 0 &&
            filteredSkills.map((industrydetails, index) => {
              return (
                <TreeView
                key={index}
                  nodeLabel={industrydetails.industry}
                  defaultCollapsed={false}
                  className="treeViewIconSize"
                >
                  <div className="col ">
                    {industrydetails.categories.length > 0 &&
                      industrydetails.categories.map((category, index) => {
                        return (
                          <div key={index}>
                            {category.name == null || category.name == " " ? (
                              <div>
                                {/* {console.log(
                                  "The show value is " + JSON.stringify(show)
                                )} */}
                                {category.skills.length > 0 &&
                                  category.skills.map((skill, index) => {
                                    return (
                                      <>
                                        {/* {console.log(
                                          "The index value is " +
                                            show.indexOf(skill)
                                        )} */}
                                        {/* {show.indexOf(skill) == -1 && ( */}
                                          <>
                                            {" "}
                                            <div className="col-12">
                                              {/* {console.log(
                                                "Enter the if conditon"
                                              )} */}
                                              <div className="row">
                                                <div className="">
                                                  <label>
                                                    <input
                                                      id="skill"
                                                      type="checkbox"
                                                      className="input_skill"
                                                      onChange={(e) =>
                                                        handleCheck(e, skill)
                                                      }
                                                    />{" "}
                                                    {skill.name}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        {/* )} */}
                                      </>
                                    );
                                  })}
                              </div>
                            ) : (
                              <div>
                                <TreeView
                                  nodeLabel={category.name}
                                  defaultCollapsed={false}
                                  className="treeViewIconSize"
                                >
                                  <div>
                                    {category.skills.length > 0 &&
                                      category.skills.map((skill, index) => {
                                        return (
                                              <div  key={index}>
                                                {" "}
                                                <div className="col-12">
                                                  
                                                  <div className="row">
                                                    <div className="">
                                                      <label>
                                                        <input
                                                          id="skill"
                                                          type="checkbox"
                                                          className="input_skill"
                                                          checked={checkCheckedStatus(skill)}
                                                          onChange={(e) =>
                                                            handleCheck(
                                                              e,
                                                              skill
                                                            )
                                                          }
                                                        />{" "}
                                                        {skill.name}
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                        );
                                       
                                      })}
                                  </div>
                                </TreeView>
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </TreeView>
              );
            })}
        {filteredSkills.length == 0 && (
                <div className="t-nodata mt-4">
                  <strong>Skill not found</strong>
                </div>
              )}
        </ModalBody>

        <ModalFooter className="p-4">
          <Button color="primary" size="sm" outline onClick={onAddSkillSearch}>
            Save
          </Button>{" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={onCancleSkillSearch}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default SkillSearch;